import {Component, ElementRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {Observable} from 'rxjs/Observable';
import {PaginationInstance} from 'ngx-pagination';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {MstStaffService} from '../../configuration/mst-staff/mst-staff.service';
import {MipdAdmissionTypeService} from '../../configuration/mipd-admission-type/mipd-admission-type.service';
import {MipdDischargeDestinationService} from '../../configuration/mipd-discharge-destination/mipd-discharge-destination.service';
import {MipdDischargeTypeService} from '../../configuration/mipd-discharge-type/mipd-discharge-type.service';
import {DischargeService} from './discharge.service';
import 'moment/min/locales.min';
import {TrnDischargeApproveUserListService} from '../../configuration/trn-discharge-approve-user-list/trn-discharge-approve-user-list.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DateConverService} from '../../shared/custom-service/DateConvert.service';
import {isBillReqiredForDischarge, pharmacybillcheck, Shatabdi} from '../../shared/my-constants';
import {TinvPharmacySaleService} from '../../inventory/tinv-pharmacy-sale/tinv-pharmacy-sale.service';
import {TbillBillService} from '../../billing/tbill-bill/tbill-bill.service';
import {PatientRegistrationService} from '../../opd/patient-registration/patient-registration.service';

@Component({
    selector: 'app-discharge',
    templateUrl: './discharge.component.html',
    styleUrls: []
})
export class DischargeComponent implements OnInit {
    trnDischarge: any = {};
    trnDischargeList: Observable<any[]>;
    loading: boolean;
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };
    currentUserdetails: any;
    qString: any = 'qString';
    AddForm: FormGroup;
    EditForm: FormGroup;
    SearchForm: FormGroup;
    dischargeviewtype: string = 'list';
    selectedpatient: any;
    ispatientselected: any;
    selectedpatientid: any;
    patientList: Array<any> = [];
    mipdDischargeDestinationList: Array<any> = [];
    mstStaffList: Array<any> = [];
    mipdDischargeTypeList: Array<any> = [];
    trnDischargeApproveUserListList: Array<any> = [];
    base_path: any;
    unitID: any;
    admission_id: any;
    today: Date = new Date();
    datePickerConfig: any;
    dateObject: any;
    maxDate: Date = new Date();
    date: any = new Date();
    time: any = (this.date.getHours().toString().length == 2 ? this.date.getHours() : '0' + this.date.getHours()) + ':' + (this.date.getMinutes().toString().length == 2 ? this.date.getMinutes() : '0' + this.date.getMinutes()) + ':' + (this.date.getSeconds().toString().length == 2 ? this.date.getSeconds() : '0' + this.date.getSeconds());
    today1: any = this.date.getFullYear() + '-' + ((this.date.getMonth() + 1).toString().toString().length == 1 ? '0' + (this.date.getMonth() + 1) : +(this.date.getMonth() + 1)) + '-' + (this.date.getDate().toString().length == 1 ? '0' + this.date.getDate() : this.date.getDate()) + 'T' + this.time;
    dt: any = this.date.getFullYear() + '-' + ((this.date.getMonth() + 1).toString().toString().length == 1 ? '0' + (this.date.getMonth() + 1) : +(this.date.getMonth() + 1)) + '-' + (this.date.getDate().toString().length == 1 ? '0' + this.date.getDate() : this.date.getDate()) + 'T' + this.time;
    /*dt: any = this.date.getFullYear() + '-' + ((this.date.getMonth() + 1).toString().toString().length == 1 ? '0' + (this.date.getMonth() + 1) : +(this.date.getMonth() + 1)) + '-' + (this.date.getDate().toString().length == 1 ? '0' + this.date.getDate() : this.date.getDate()) + 'T' + this.date.toLocaleTimeString().toString().split(' ')[0];*/
    options: any;
    billdate: Boolean = false;
    shatabdi: boolean = Shatabdi;
    isBillReqiredForDischarge: boolean = isBillReqiredForDischarge;
    pharmacybillcheck: boolean = pharmacybillcheck;
    @ViewChild('myDate') myDate: ElementRef;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private TrnAdmissionService: TrnAdmissionService,
                private mstStaffService: MstStaffService,
                private DischargeService: DischargeService,
                private MipdAdmissionTypeService: MipdAdmissionTypeService,
                private MipdDischargeDestinationService: MipdDischargeDestinationService,
                private MipdDischargeTypeService: MipdDischargeTypeService,
                private TrnDischargeApproveUserListService: TrnDischargeApproveUserListService,
                private TinvPharmacySaleService: TinvPharmacySaleService,
                private tbillBillService: TbillBillService,
                private patientRegistrationService: PatientRegistrationService,
                private fb: FormBuilder,
                public toastr: ToastsManager,
                vcr: ViewContainerRef,
                private dateConverService: DateConverService,
                public datepipe: DatePipe) {
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.options = {
            locale: {format: 'DD-MM-YYYY HH:mm:ss'},
            alwaysShowCalendars: false,
            timePicker: true,
            singleDatePicker: true,
            showDropdowns: true,
            maxDate: this.datepipe.transform(this.today, 'DD-MM-YYYY HH:mm:ss')
        };
        this.toastr.setRootViewContainerRef(vcr);
        this.AddForm = this.fb.group({
            'dischargeAdmissionId': this.fb.group({
                'admissionId': [null, Validators.required]
            }),
            'dischargeStaffId': this.fb.group({
                'staffId': [null, Validators.required]
            }),
            'dischargeType': this.fb.group({
                'dtId': [null, Validators.required]
            }),
            'dischargeDestination': this.fb.group({
                'ddId': [null, Validators.required]
            }),
            'dischargeComment': [null],
            'dischargeDate': [null, Validators.required],
            'persionDischargeDate': [null],
            'dischargeStatus': [0],
            'isDeathDischarge': [0],
            'createdBy': [this.currentUserdetails.staffUserId.userFullname]
        });
        this.EditForm = this.fb.group({
            'dischargeAdmissionId': fb.group({
                'admissionId': [null, Validators.required]
            }),
            'dischargeStaffId': this.fb.group({
                'staffId': ['', Validators.required]
            }),
            'dischargeType': this.fb.group({
                'dtId': [null, Validators.required]
            }),
            'dischargeDestination': this.fb.group({
                'ddId': [null, Validators.required]
            }),
            'dischargeComment': [null],
            'dischargeDate': [this.dt, Validators.required],
            'persionDischargeDate': [null],
            'dischargeStatus': [0],
            'isDeathDischarge': [0],
            'lastModifiedBy': [this.currentUserdetails.staffUserId.userFullname]
        });
        this.SearchForm = fb.group({
            'dischargeAdmissionId': fb.group({
                'admissionId': [null, Validators.required]
            }),
            'dischargeStaffId': fb.group({
                'staffId': [null, Validators.required]
            }),
            'dischargeType': fb.group({
                'dtId': [null, Validators.required]
            }),
            'dischargeDestination': fb.group({
                'ddId': [null, Validators.required]
            }),
            'dischargeComment': [null],
            'dischargeDate': [null, Validators.required],
            'persionDischargeDate': [null, Validators.required],
            'dischargeStatus': [0],
            'isDeathDischarge': [0, Validators.required]
        });
    }

    ngOnInit() {
        // let mr_no_search: String;
        this.route.params.subscribe(params => {
            this.admission_id = params['admission_id'];
            // console.log('this.mr1', this.admission_id);
        });
        this.selectedpatient = {};
        if (this.admission_id != undefined && this.admission_id != null) {
            this.TrnAdmissionService.getRecordService(this.admission_id).then(resp15 => {
                // console.log('admision object', resp15);
                this.onChangeMrNo(resp15);
            });
        }
        this.billdate = false;
        this.dt = this.date.getFullYear() + '-' + ((this.date.getMonth() + 1).toString().toString().length == 1 ? '0' + (this.date.getMonth() + 1) : +(this.date.getMonth() + 1)) + '-' + (this.date.getDate().toString().length == 1 ? '0' + this.date.getDate() : this.date.getDate()) + 'T' + this.time;
        /*this.dt = this.date.getFullYear() + '-' + ((this.date.getMonth() + 1).toString().toString().length == 1 ? '0' + (this.date.getMonth() + 1) : +(this.date.getMonth() + 1)) + '-' + (this.date.getDate().toString().length == 1 ? '0' + this.date.getDate() : this.date.getDate()) + 'T' + this.date.toLocaleTimeString().toString().split(' ')[0];*/
        // console.log('date and time',this.dt);
        this.unitID = JSON.parse(sessionStorage.getItem('unitId'));
        this.dateObject = '';
        this.getbasepath();
        this.onViewSelect('add');
        // this.getPage(1);
        this.mstStaffService.getAlldoctorlist().then(resp => {
            this.mstStaffList = resp;
        });
        this.MipdDischargeDestinationService.getAllRecordService('', '', '', '', '').then(resp => {
            this.mipdDischargeDestinationList = resp.content;
        });
        this.MipdDischargeTypeService.getAllRecordService('', '', '', '', '').then(resp => {
            this.mipdDischargeTypeList = resp.content;
        });
    }

    public selectedDate(value: any) {
        console.log('this.dt ', this.dt);
        if (this.dt > this.selectedpatient.admissionDate) {
            this.AddForm.controls.dischargeDate.setValue(this.dt);
        } else {
            this.toastr.warning('Discharge Date Must Be Grater Than Admission Date');
            this.dt = this.date.getFullYear() + '-' + ((this.date.getMonth() + 1).toString().toString().length == 1 ? '0' + (this.date.getMonth() + 1) : +(this.date.getMonth() + 1)) + '-' + (this.date.getDate().toString().length == 1 ? '0' + this.date.getDate() : this.date.getDate()) + 'T' + this.time;
        }
    }

    // selectedDate(date: any) {
    //
    //
    //   this.AddForm.controls.dischargeDate.setValue(this.dateObject);
    //   this.AddForm.controls.persionDischargeDate.setValue(this.dateConverService.getPersianDate(this.dateObject));
    //   // if(Iran){
    //   //   this.AddForm.controls.dischargeDate.setValue(this.dateObject);
    //   //   this.AddForm.controls.persionDischargeDate.setValue(this.dateConverService.getPersianDate(this.dateObject));
    //   // }
    //   // else{
    //   //   this.AddForm.controls.dischargeDate.setValue(this.dateObject);
    //   //   this.AddForm.controls.persionDischargeDate.setValue(this.dateConverService.getPersianDate(this.dateObject));
    //   // }
    // }
    onChangeMrNo(event: any) {
        this.selectedpatient = event;
        console.log(event);
        this.ispatientselected = event.admissionId;
        this.selectedpatientid = event.admissionPatientId.patientId;
        this.AddForm.controls.dischargeStaffId.get('staffId').setValue(event.admissionStaffId.staffId);
        this.TrnDischargeApproveUserListService.getAllAdmissionIDRecordService(event.admissionId)
            .then(resp => {
                this.trnDischargeApproveUserListList = resp;
            });
    }

    searchPatientByMrnounit(event) {
        let qString: string = event.query;
        this.TrnAdmissionService.getmrnounitwiseautocomplite(qString, this.unitID).then(
            resp => {
                // console.log(resp);
                this.patientList = resp.record;
            });
    }

    getbasepath() {
        this.DischargeService.gatbasepath().then(
            resp => {
                this.base_path = resp._body;
            }
        );
    }

    onViewSelect(value: any) {
        switch (value) {
            case 'add':
                this.dischargeviewtype = 'add';
                this.AddForm.reset();
                break;
            case 'edit':
                this.dischargeviewtype = 'edit';
                break;
            case 'view':
                this.dischargeviewtype = 'view';
                break;
            case 'list':
                this.dischargeviewtype = 'list';
                break;
            case 'search':
                this.dischargeviewtype = 'search';
                break;
            default:
                this.dischargeviewtype = 'list';
                break;
        }
    }

    getPage(page: number) {
        this.loading = true;
        this.DischargeService.getAllRecordService(page, this.config.itemsPerPage, '', '', '')
            .then(resp => {
                // console.log(resp);
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                this.loading = false;
                this.trnDischargeList = resp.content;
            });
    }

    onAddRecord(model: any) {
        console.log('model', model);
        model.createdBy = this.currentUserdetails.staffUserId.userFullname;

        console.log('ispatientselected', this.ispatientselected);
        if (this.ispatientselected == undefined || this.ispatientselected == '' || this.ispatientselected == null) {
            this.toastr.warning('Please Search Patient', 'Warning ! ');
        } else if (model.dischargeStaffId.staffId == null || model.dischargeStaffId.staffId == '') {
            this.toastr.warning('Please Select Discharge Doctor', 'Warning ! ');
        } else if (model.dischargeType.dtId == null || model.dischargeType.dtId == '') {
            this.toastr.warning('Please Select Discharge Type', 'Warning ! ');
        } else if (model.dischargeDestination.ddId == null || model.dischargeDestination.ddId == '') {
            this.toastr.warning('Please Select Discharge Destination', 'Warning ! ');
        } else {
            if (pharmacybillcheck) {
                this.DischargeService.checkfinalbillService(this.ispatientselected).then(resp => {
                    // if (resp || true) { here we r ristring user to make final bill before discharge
                    if (resp || this.isBillReqiredForDischarge) {
                        this.TinvPharmacySaleService.checkPharmacyOutstandingPay(this.ispatientselected).then(resppharmacy => {
                            // console.log(resppharmacy);
                            // if (resppharmacy) { using this we r ristricting the user to make final bill before discharge
                            if (resppharmacy) {
                                this.toastr.info('Pharmacy Final Bill Not Approve');
                            } else {
                                model.dischargeAdmissionId.admissionId = this.ispatientselected;
                                model.dischargeDate = this.dt;
                                model.createdBy = this.currentUserdetails.staffUserId.userFullname;
                                this.DischargeService.addRecordService(model).then(resp => {
                                    if (resp.success === '1') {
                                        this.AddForm.reset();
                                        if (this.billdate) {
                                            this.tbillBillService.finalbilldatechange(model.dischargeAdmissionId.admissionId);
                                        }
                                        this.toastr.success(resp.msg, 'Discharge Approved');
                                        if (this.shatabdi) {
                                            this.patientRegistrationService.sendmessageDischargeSuccess(this.selectedpatient).then(resp => {
                                                console.log(' discharge sms', resp);
                                            });
                                        }
                                        this.router.navigate(['/ipd/dischargelist']);
                                    } else {
                                        this.toastr.error(resp.msg, 'Failed !');
                                    }
                                });
                            }
                        });
                    } else {
                        //this.toastr.info('Final Bill Not Approve');
                    }
                });
            } else {
                this.DischargeService.checkfinalbillService(this.ispatientselected).then(resp => {
                    // if (resp || true) { here we r ristring user to  make final bill before discharge
                    if (resp || this.isBillReqiredForDischarge) {
                        model.dischargeAdmissionId.admissionId = this.ispatientselected;
                        model.dischargeDate = this.dt;
                        this.DischargeService.addRecordService(model).then(resp => {
                            if (resp.success === '1') {
                                if (this.billdate) {
                                    this.tbillBillService.finalbilldatechange(model.dischargeAdmissionId.admissionId);
                                }
                                if (this.shatabdi) {
                                    this.patientRegistrationService.sendmessageDischargeSuccess(this.selectedpatient).then(resp => {
                                        console.log(' discharge sms', resp);
                                    });
                                }
                                this.toastr.success(resp.msg, 'Discharge Approved');
                                this.router.navigate(['/ipd/dischargelist']);
                            } else {
                                this.toastr.error(resp.msg, 'Failed !');
                            }
                        });
                    } else {
                        this.toastr.info('Final Bill Not Approve');
                    }
                });
            }
            this.AddForm.reset();
        }
    }

    cancel() {
        this.router.navigate(['/ipd/dischargelist']);
    }

    onEditRecord(model: any) {
        model.dischargeId = this.trnDischarge.dischargeId;
        this.DischargeService.editRecordService(model).then(resp => {
            // console.log(resp);
            this.ngOnInit();
        });
    }

    onDeleteRecord(id: any) {
        // console.log(id);
        this.DischargeService.deleteRecordService(id).then(resp => {
            if (resp.success === '1') {
                this.toastr.success(resp.msg, 'Success ! ');
                // console.log(resp);
                this.ngOnInit();
            } else {
                this.toastr.error(resp.msg, 'Failed ! ');
                // console.log(resp);
            }
        });
    }

    onRecordByID(id: any, view: any) {
        // console.log(id);
        this.DischargeService.getRecordService(id).then(resp => {
            this.trnDischarge = resp;
            if (view === 'edit') {
                this.onViewSelect('edit');
            } else if (view === 'view') {
                this.onViewSelect('view');
            }
        });
    }

    onSearchRecord(key: any) {
        // console.log(key);
        if (key === '') {
            this.qString = 'qString';
        }
        else {
            this.qString = key;
        }
    }

    //pagination methods
    onRecordCountChange(records: number) {
        this.config.itemsPerPage = records;
        this.getPage(this.config.currentPage);
    }

    saveforbill(event: any) {
        if (event.target.checked) {
            this.billdate = true;
        } else {
            this.billdate = false;
        }
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge/discharge.component.ts